(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["liminal-log"] && !Shopify.designMode) return;
  try {
    
  const initialiseLiminalLogFilters = (root) => {
    if (!root || root.dataset.logFiltersReady === 'true') return;

    const filters = root.querySelectorAll('[data-log-filter]');
    const entries = root.querySelectorAll('[data-log-entry]');
    const emptyMessage = root.querySelector('[data-log-empty]');
    if (!filters.length || !entries.length) return;

    root.dataset.logFiltersReady = 'true';

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        const selectedTag = filter.dataset.logFilter;
        let visibleEntries = 0;

        filters.forEach((item) => {
          const isSelected = item === filter;
          item.classList.toggle('is-active', isSelected);
          item.setAttribute('aria-pressed', String(isSelected));
        });

        entries.forEach((entry) => {
          const tags = entry.dataset.logTags.trim().split(/\s+/);
          const shouldShow = selectedTag === 'all' || tags.includes(selectedTag);
          entry.hidden = !shouldShow;
          if (shouldShow) visibleEntries += 1;
        });

        if (emptyMessage) emptyMessage.hidden = visibleEntries !== 0;
      });
    });
  };

  document.querySelectorAll('.liminal-log').forEach(initialiseLiminalLogFilters);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.liminal-log').forEach(initialiseLiminalLogFilters);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
